import type { Snack } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { SnackZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "parentID", "uuid", "snack", "createdAt", "updatedAt"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type DesignSnackFormBaseModel = AutoGeneratorForFormModel<
	SnackZodSchemaType, //
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;

export type ServerModel = Snack;
